import styled from 'styled-components'
import { transparentize } from 'polished'

export const Wrapper = styled.table`
  width: 100%;
  color: #274060;
  background-color: ${transparentize(0.95, '#274060')};

  html.dark & {
    color: #e2e8f0;
    background-color: #1f2937;
  }
`

export const Heading = styled.thead`
  background-color: ${transparentize(0.85, '#274060')};

  html.dark & {
    background-color: #374151;
  }
`

export const HeadingRow = styled.tr``

export const HeadingCell = styled.th`
  height: 32px;
  font-size: 14px;
  padding: 0 8px;

  html.dark & {
    color: #e2e8f0;
  }
`

export const Body = styled.tbody``

export const BodyRow = styled.tr`
  html.dark & {
    border-bottom-color: #374151;
  }

  html.dark &:hover {
    background-color: #374151;
  }
`

export const BodyCell = styled.td`
  height: 40px;
  font-size: 12px;
  font-weight: 500;
  padding: 0 8px;

  html.dark & {
    color: #e2e8f0;
  }
`

export const NoDataWrapper = styled.div`
  background-color: ${transparentize(0.95, '#274060')};

  html.dark & {
    background-color: #1f2937;
  }
`